/**
 * CK Header
 * Hamburger toggle. Sticky is handled via CSS (position: sticky on #ck-nav-sticky).
 **/

import Logger from "./logger";

const NAME = "Header";

export default function initHeader() {
	Logger.info(`${NAME} > init`);

	// ── Hamburger toggle ─────────────────────────────────────────────────────

	const hamburger = document.querySelector(".js-ck-hamburger");
	const detailedMenu = document.getElementById("ck-detailed-menu");

	if (!hamburger || !detailedMenu) return;

	function openMenu() {
		hamburger.setAttribute("aria-expanded", "true");
		detailedMenu.hidden = false;
		// Let the browser paint the element (display:flex) before adding the class,
		// so the CSS transition has a start state to animate from.
		requestAnimationFrame(() => detailedMenu.classList.add("is-open"));
	}

	const mobileQuery = window.matchMedia("(max-width: 767px)");

	function closeMenu() {
		hamburger.setAttribute("aria-expanded", "false");
		detailedMenu.classList.remove("is-open");
		if (mobileQuery.matches) {
			// Wait for the slide-up transition to finish before hiding.
			detailedMenu.addEventListener(
				"transitionend",
				() => { detailedMenu.hidden = true; },
				{ once: true }
			);
		} else {
			detailedMenu.hidden = true;
		}
	}

	// Both the hamburger and the close button carry .js-ck-hamburger
	document.querySelectorAll(".js-ck-hamburger").forEach((btn) => {
		btn.addEventListener("click", (e) => {
			e.stopPropagation();
			const isOpen = hamburger.getAttribute("aria-expanded") === "true";
			isOpen ? closeMenu() : openMenu();
		});
	});

	// Close on outside click
	document.addEventListener("click", (e) => {
		const isOpen = hamburger.getAttribute("aria-expanded") === "true";
		if (isOpen && !hamburger.contains(e.target) && !detailedMenu.contains(e.target)) {
			closeMenu();
		}
	});

	// Close on Escape
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") closeMenu();
	});

	// ── Cart drawer: suppress scroll-position restore on close ──────────────

	const cartDrawer = document.querySelector("cart-drawer-component");
	if (cartDrawer) {
		const originalClose = cartDrawer.closeDialog.bind(cartDrawer);
		cartDrawer.closeDialog = async (...args) => {
			const original = window.scrollTo;
			window.scrollTo = (options) => {
				// Only suppress instant scroll-restores triggered by dialog close.
				// Allow all other scrollTo calls through.
				if (options && options.behavior === "instant") return;
				original.call(window, options);
			};
			await originalClose(...args);
			window.scrollTo = original;
		};
	}

	Logger.info(`${NAME} > loaded`);
}
